import React, { useState } from 'react'
import { Editor } from 'react-draft-wysiwyg'
import {} from 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css'
import { AtomicBlockUtils, EditorState, convertToRaw, ContentState } from 'draft-js'
import draftToHtml from 'draftjs-to-html'
import htmlToDraft from 'html-to-draftjs'
import { WYSIWYG_TOOLBAR } from '../../../constant/global/Config'
import { InteractorFileUpload } from '../../../interactors/Main'
import { useSelector } from 'react-redux'

const InputWYSIWYG = (data) => {
  const blocksFromHtml = htmlToDraft(data.value)
  const { contentBlocks, entityMap } = blocksFromHtml
  const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap)
  const [editorState, setEditorState] = useState(EditorState.createWithContent(contentState))
  const { uploadFile } = InteractorFileUpload()
  const { seller } = useSelector((state) => state.seller)

  const onBlurSaveState = (_, editor) => {
    const value = convertToRaw(editor.getCurrentContent())
    data.handleValue(draftToHtml(value))
  }

  const onEditorStateChange = (editorState) => {
    setEditorState(editorState)
  }

  const insertImage = (url) => {
    const contentState = editorState.getCurrentContent()
    const contentStateWithEntity = contentState.createEntity('IMAGE', 'IMMUTABLE', { src: url })
    const entityKey = contentStateWithEntity.getLastCreatedEntityKey()
    const newEditorState = EditorState.set(editorState, { currentContent: contentStateWithEntity })
    return AtomicBlockUtils.insertAtomicBlock(newEditorState, entityKey, ' ')
  }

  function onEditorUploadCallback(file) {
    return new Promise((resolve) => {
      uploadFile(
        {
          type: 'PUBLIC',
          category: 'PRODUCT_DESCRIPTION',
          file: file,
          reference_uid: seller.uid,
        },
        (result) => {
          insertImage(result.data[0].url)
          resolve({ data: { link: result.data[0].url } })
        },
      )
    })
  }

  return (
    <Editor
      editorState={editorState}
      toolbarClassName="toolbarClassName"
      wrapperClassName="wrapperClassName"
      editorClassName="editorClassName"
      onBlur={onBlurSaveState}
      wrapperStyle={{
        border: '1px solid #DDDDDD',
      }}
      editorStyle={{
        padding: '10px',
      }}
      toolbar={WYSIWYG_TOOLBAR}
      uploadCallback={onEditorUploadCallback}
      onEditorStateChange={onEditorStateChange}
    />
  )
}

export default InputWYSIWYG
